import { RequestResult, RequestResultValue } from "../../common/api/requestResult";
import { HttpService } from "../../common/api/httpService";
import JSONbig from "json-bigint";
import { AdminGameFilterInfo } from "../../models/gameFilters";

export async function gameFiltersListApi(gameId: number): Promise<RequestResultValue<AdminGameFilterInfo[]>> {
    const response = await HttpService.getInstance().requestGetAsync(`admin/gameFilters?gameId=${gameId}`);
    const text = await response.text();
    const body = JSONbig.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<AdminGameFilterInfo[]>(true, body as AdminGameFilterInfo[]);
    }
    return new RequestResultValue<AdminGameFilterInfo[]>(false);
}

export async function updateGameFiltersApi(gameId: number, filter: AdminGameFilterInfo): Promise<RequestResult> {
    const response = await HttpService.getInstance().requestPutAsync(
        `admin/gameFilters`,
        JSONbig.stringify({
            gameId,
            filters: [filter],
        }),
    );
    if (response.status >= 200 && response.status < 300) {
        return new RequestResult(true);
    }
    const text = await response.text().catch(() => '');
    let body: any = undefined;
    try {
        body = text ? JSONbig.parse(text) : undefined;
    } catch {
        body = text;
    }
    return new RequestResult(false, body);
}

export async function updateGameFiltersGroupApi(gameId: number, filters: AdminGameFilterInfo[]): Promise<RequestResult> {
    const response = await HttpService.getInstance().requestPutAsync(
        `admin/gameFilters`,
        JSONbig.stringify({
            gameId,
            filters,
        }),
    );
    if (response.status >= 200 && response.status < 300) {
        return new RequestResult(true);
    }
    const text = await response.text().catch(() => '');
    let body: any = undefined;
    try {
        body = text ? JSONbig.parse(text) : undefined;
    } catch {
        body = text;
    }
    return new RequestResult(false, body);
}


